import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { I as IconButton } from '../../Button/IconButton/IconButton-Copc-LdF.js';
import { i as isDarkTheme } from '../../theme/style-mixins/isDarkTheme/isDarkTheme-DFKPsgi7.js';
import { T as TaktIdProvider, w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { F as expand, G as collapse } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const NavWrapper = /*#__PURE__*/styled.nav.withConfig({
  componentId: "sc-storm-ui-40027066__sc-qqzefi-0"
})(["display:flex;flex-direction:column;align-items:flex-end;overflow-y:auto;overflow-x:hidden;background-color:", ";gap:", ";padding-block:", ";padding-inline:", ";border-inline-end:", ";", ";"], ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.border.subtle.default, isDarkTheme(css(["background-color:", ";"], ({
  theme
}) => theme.surface.offset)));
const TaktedIconButton = withTaktFallbackId(IconButton);

// @TODO: (storm-v4) add rtl collapse/expand to @amzn/storm-ui-icons
const StyledIconButton = /*#__PURE__*/styled(TaktedIconButton).withConfig({
  componentId: "sc-storm-ui-40027066__sc-qqzefi-1"
})(["/*! @noflip */ [dir=\"rtl\"] && svg{/*! @noflip */ transform:scaleX(-1);}"]);
const TRANSITION_CLASSNAME_PREFIX = 'sidenav-ul-transition';
const TRANSITION_DURATION = 300;
const transitionStyle = /*#__PURE__*/css(["opacity:0;width:0;"]);
const transitionDoneStyle = /*#__PURE__*/css(["", " & > *{display:none;}"], transitionStyle);
const NavContainer = /*#__PURE__*/styled('ul').withConfig({
  componentId: "sc-storm-ui-40027066__sc-qqzefi-2"
})(["padding:0;margin:0;list-style:none;flex:1;align-self:flex-start;display:flex;flex-direction:column;align-items:stretch;{}[role=separator]{margin-block:", ";}opacity:1;width:", ";@media (prefers-reduced-motion:no-preference){transition:opacity ", "ms ease-in-out,width ", "ms ease-in-out;}&&.", "-appear{", ";}&&.", "-enter{", "}&&.", "-enter-active{", "}&&.", "-enter-done{", "}"], ({
  theme
}) => theme.spacing.xxxsmall.default, ({
  $width,
  theme
}) => $width !== null && $width !== void 0 ? $width : theme.sideNavigation.width, TRANSITION_DURATION, TRANSITION_DURATION, TRANSITION_CLASSNAME_PREFIX, ({
  collapsed
}) => collapsed && transitionDoneStyle, TRANSITION_CLASSNAME_PREFIX, transitionStyle, TRANSITION_CLASSNAME_PREFIX, transitionStyle, TRANSITION_CLASSNAME_PREFIX, transitionDoneStyle);
const StatelessSideNav = ({
  taktId,
  taktValue,
  children,
  width,
  onToggleCollapse,
  collapsable = true,
  isCollapsed,
  expandScreenReaderLabel = 'Show navigation menu',
  collapseScreenReaderLabel = 'Hide navigation menu',
  ariaLabel = 'Sidebar',
  ...rest
}) => {
  const navContainerRef = useRef(null);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('side-nav')
  }, /*#__PURE__*/React__default.createElement(NavWrapper, _extends({}, rest, {
    "aria-label": ariaLabel
  }), collapsable && /*#__PURE__*/React__default.createElement(StyledIconButton, {
    variant: "transparent",
    icon: isCollapsed ? expand : collapse,
    label: isCollapsed ? expandScreenReaderLabel : collapseScreenReaderLabel,
    onClick: () => {
      if (typeof onToggleCollapse === 'function') {
        onToggleCollapse(!isCollapsed);
      }
    },
    "aria-expanded": !isCollapsed,
    taktFallbackId: createStormTaktId('expander-toggle')
  }), /*#__PURE__*/React__default.createElement(CSSTransition, {
    timeout: TRANSITION_DURATION,
    appear: true,
    in: isCollapsed && collapsable,
    nodeRef: navContainerRef,
    classNames: TRANSITION_CLASSNAME_PREFIX
  }, /*#__PURE__*/React__default.createElement(NavContainer, {
    $width: width,
    ref: navContainerRef,
    collapsed: isCollapsed && collapsable
  }, children))));
};

export { StatelessSideNav as S };
//# sourceMappingURL=StatelessSideNav-CTV9TsuS.js.map
